"use client"

import { useState } from "react"
import { Menu, X } from "lucide-react"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"

type MobileMenuProps = {
  customer?: HttpTypes.StoreCustomer | null
}

const MobileMenu = ({ customer }: MobileMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="relative">
      {/* Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="flex items-center justify-center p-2 text-white"
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        {isOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <Menu className="h-6 w-6" />
        )}
      </button>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex flex-col">
          <div className="flex justify-between items-center p-4 border-b border-white/10">
            <div className="flex items-center">
              <img
                src="/assets/logo_black-02.svg"
                alt=""
                style={{
                  filter: "invert(1)",
                  height: "30px",
                }}
              />
              <img
                src="/assets/logo_black-01.svg"
                alt=""
                style={{
                  filter: "invert(1)",
                  height: "10px",
                }}
                className="ml-2"
              />
            </div>
            <button
              onClick={toggleMenu}
              className="text-white p-2"
              aria-label="Close menu"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="flex flex-col items-center justify-center flex-1 gap-8 text-white p-8">
            <LocalizedClientLink
              href="/"
              className="text-2xl font-medium hover:text-gray-300 transition-colors border-b-2 border-transparent hover:border-white py-1 px-4"
              onClick={toggleMenu}
            >
              Home
            </LocalizedClientLink>

            <LocalizedClientLink
              href="/store"
              className="text-2xl font-medium hover:text-gray-300 transition-colors border-b-2 border-transparent hover:border-white py-1 px-4"
              onClick={toggleMenu}
            >
              Products
            </LocalizedClientLink>

            {customer ? (
              <LocalizedClientLink
                href="/profile"
                className="text-2xl font-medium hover:text-gray-300 transition-colors border-b-2 border-transparent hover:border-white py-1 px-4"
                onClick={toggleMenu}
              >
                Profile
              </LocalizedClientLink>
            ) : (
              <LocalizedClientLink
                href="/account"
                className="text-2xl font-medium hover:text-gray-300 transition-colors border-b-2 border-transparent hover:border-white py-1 px-4"
                onClick={toggleMenu}
              >
                Sign In
              </LocalizedClientLink>
            )}

            <LocalizedClientLink
              href="/cart"
              className="text-2xl font-medium hover:text-gray-300 transition-colors border-b-2 border-transparent hover:border-white py-1 px-4"
              onClick={toggleMenu}
            >
              Cart
            </LocalizedClientLink>
          </div>

          <div className="p-4 text-center text-white/60 text-sm border-t border-white/10">
            © {new Date().getFullYear()} Spark Store. All rights reserved.
          </div>
        </div>
      )}
    </div>
  )
}

export default MobileMenu
